import { useState, Fragment } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import "./style.css";
import axios from "axios";
const FileUploader = ({}) => {
  const [file, setFile] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [open, setOpen] = useState(false);
  const handleSnackClick = () => {
    setOpen(true);
  };

  const handleSnackClose = (event) => {
    setOpen(false);
  };

  const action = (
    <Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleSnackClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  );

  const onInputChange = (e) => {
    setFile(e.target.files[0]);
    console.log(e.target.files[0]);

    let fileType = e.target.files[0].type;

    if (fileType !== "text/csv") {
      e.target.value = null;
      setFile(null);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    // axios.
    const data = new FormData();
    data.append("file", file);
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    };
    setSuccessMessage("Upload Success");
    handleSnackClick();
    let uploadFile = await axios.post(
      `${process.env.REACT_APP_API}/upload`,
      data,
      config
    );

    //fire update RPI
    let fireRPI = await axios.post(
      `${process.env.REACT_APP_API}/gomicAPIWrapper`,
      config
    );
  };

  let renderSuccessMsg = <></>;

  if (successMessage) {
    renderSuccessMsg = <div>{successMessage}</div>;
  }

  return (
    <div className="row">
      <div className="col-md-6">
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          open={open}
          autoHideDuration={6000}
          onClose={handleSnackClose}
          message={successMessage}
          action={action}
        />
        <form>
          <div className="form-group files">
            <input
              type="file"
              onChange={onInputChange}
              class="form-control"
              accept=".csv"
            />
          </div>
          <button onClick={onSubmit}>Submit</button>
        </form>
      </div>
    </div>
  );
};

export default FileUploader;
